export const categoryFacetSearchStateSelector = (state, facetId) => state.categoryFacetSearchSet[facetId];
